// Moved out of SMSConversationManager.jsx on 29 Sep 2026 so Karma Text Booking
// can use the same colleague search (TeamsNotifyPicker.jsx).
import getApiToken from './getApiToken';

/**
 * Finds colleagues in Microsoft 365 for the Teams notification picker.
 *
 * Needs the delegated Graph permission User.ReadBasic.All, which is
 * admin-consent-only. Without it Graph returns 403 and the picker falls back to
 * typing an address by hand, so the feature degrades rather than breaks.
 */
export const searchDirectoryPeople = async (instance, query) => {
  const account = instance.getActiveAccount();
  const request = { scopes: ['User.ReadBasic.All'], account };

  const token = await getApiToken(instance, request);

  const search = encodeURIComponent(`"displayName:${query}" OR "mail:${query}"`);
  const url = `https://graph.microsoft.com/v1.0/users?$search=${search}`
    + '&$select=displayName,mail,userPrincipalName,jobTitle&$top=15';

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      // $search on /users requires this header.
      ConsistencyLevel: 'eventual'
    }
  });

  if (!response.ok) {
    const detail = await response.text().catch(() => '');
    if (response.status === 403) {
      throw new Error('Not permitted to look up colleagues. An administrator needs to grant User.ReadBasic.All.');
    }
    throw new Error(`Directory search failed (${response.status}). ${detail.slice(0, 120)}`);
  }

  const body = await response.json();
  return (body.value || [])
    .map((user) => ({
      name: String(user.displayName || '').trim(),
      email: String(user.mail || user.userPrincipalName || '').trim(),
      jobTitle: String(user.jobTitle || '').trim()
    }))
    .filter((user) => user.email);
};

export default searchDirectoryPeople;
